import React, { useMemo } from "react";
import { ThemeProvider, createTheme } from "@mui/material";
import { MaterialReactTable } from "material-react-table";
import { useNavigate } from "react-router-dom";

const StudentViewPayment = ({ payments }) => {
  const navigate = useNavigate();
  const formatDate = (dateString) => {
    if (!dateString) return "";
    return new Date(dateString).toLocaleDateString("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
  };

  const columns = useMemo(
    () => [
      {
        accessorFn: (row, index) => index + 1,
        header: "S.NO",
        enableSorting: true,
        enableHiding: true,
        size: 40,
        cell: ({ cell }) => (
          <span style={{ textAlign: "center" }}>{cell.getValue()}</span>
        ),
      },
      {
        accessorKey: "paymentMethod",
        enableHiding: true,
        header: "Payment Method",
        size: 100,
      },
      {
        accessorKey: "paymentDate",
        enableHiding: true,
        header: "Payment Date",
        size: 100,
        Cell: ({ cell }) => formatDate(cell.getValue()),
      },
      {
        accessorKey: "paymentReference",
        enableHiding: true,
        header: "Payment Reference",
        size: 120,
        Cell: ({ cell }) => cell.getValue() || "N/A",
      },
      {
        accessorKey: "paidAmount",
        enableHiding: true,
        header: "Paid Amount",
        size: 100,
        Cell: ({ cell }) =>
          cell.getValue() ? `$${cell.getValue().toFixed(2)}` : "N/A",
      },
      {
        accessorKey: "receiptNo",
        enableHiding: true,
        header: "Receipt No",
        size: 100,
        Cell: ({ cell }) => cell.getValue() || "N/A",
      },
      {
        accessorKey: "bank",
        enableHiding: true,
        header: "Bank",
        size: 100,
        Cell: ({ cell }) => cell.getValue() || "N/A",
      },
      {
        accessorKey: "accountNo",
        enableHiding: true,
        header: "Account No",
        size: 120,
        Cell: ({ cell }) => cell.getValue() || "N/A",
      },
      {
        accessorKey: "transactionNo",
        enableHiding: true,
        header: "Transaction No",
        size: 120,
        Cell: ({ cell }) => cell.getValue() || "N/A",
      },
      {
        accessorKey: "mobileNumber",
        enableHiding: true,
        header: "Mobile Number",
        size: 120,
        Cell: ({ cell }) => cell.getValue() || "N/A",
      },
      {
        accessorKey: "invoiceNo",
        enableHiding: true,
        header: "Invoice No",
        size: 120,
      },
      {
        accessorKey: "remark",
        enableHiding: true,
        header: "Remark",
        size: 120,
        Cell: ({ cell }) => cell.getValue() || "",
      },
      {
        accessorKey: "createdAt",
        header: "Created On",
        size: 100,
        Cell: ({ cell }) => formatDate(cell.getValue()) || "",
      },
      {
        accessorKey: "createdBy",
        header: "Created By",
        size: 100,
        Cell: ({ cell }) => cell.getValue() || "",
      },
      {
        accessorKey: "updatedAt",
        header: "Updated On",
        size: 100,
        Cell: ({ cell }) => formatDate(cell.getValue()) || "",
      },
      {
        accessorKey: "updatedBy",
        header: "Updated By",
        size: 100,
        Cell: ({ cell }) => cell.getValue() || "",
      },
    ],
    []
  );

  const theme = createTheme({
    components: {
      MuiTableCell: {
        styleOverrides: {
          head: {
            color: "#535454 !important",
            backgroundColor: "#e6edf7 !important",
            fontWeight: "400 !important",
            fontSize: "13px !important",
            textAlign: "center !important",
          },
        },
      },
      MuiSwitch: {
        styleOverrides: {
          root: {
            "&.Mui-disabled .MuiSwitch-track": {
              backgroundColor: "#f5e1d0",
              opacity: 1,
            },
            "&.Mui-disabled .MuiSwitch-thumb": {
              color: "#eb862a",
            },
          },
          track: {
            backgroundColor: "#e0e0e0",
          },
          thumb: {
            color: "#eb862a",
          },
          switchBase: {
            "&.Mui-checked": {
              color: "#eb862a",
            },
            "&.Mui-checked + .MuiSwitch-track": {
              backgroundColor: "#eb862a",
            },
          },
        },
      },
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <MaterialReactTable
        columns={columns}
        data={payments || []} // Use payments prop with fallback to empty array
        enableColumnActions={false}
        enableDensityToggle={false}
        enableFullScreenToggle={false}
        initialState={{
          columnVisibility: {
            createdBy: false,
            createdAt: false,
            updatedBy: false,
            updatedAt: false,
            remark: false,
            transactionNo: false,
            mobileNumber: false,
          },
        }}
        muiTableBodyRowProps={({ row }) => ({
          onClick: () => navigate(`/payment/view/${row.original.id}`),
          style: { cursor: "pointer" },
        })}
        renderEmptyRowsFallback={() => (
          <div className="text-center py-4">No payments available.</div>
        )}
      />
    </ThemeProvider>
  );
};

export default StudentViewPayment;
